import React from 'react';
import CarnowCta from './CarnowCta';
import ContactDealerCta from './ContactDealerCta';
import CustomCta from './CustomCta';
import DarwinCta from './DarwinCta';
import GubagooCta from './GubagooCta';
import RoadsterCta from './Roadster/RoadsterCta';
import UpstartCta from './UpstartCta';
import VinRecallCta from './VinRecallCta/VinRecallCta';
import { VendorCTAType } from '../../types';

export interface VendorCtaSelectorProps {
  ctaDetails: VendorCTAType;
  variant: 'primary' | 'secondary';
  vin: string;
  vehicleId?: string;
  market?: string;
  mainDealer?: string;
  vehicleType?: string;
  carType?: string;
}

// crop obj to only use the defined properties
export const getDefinedPropertiesOfCta = (cta: VendorCTAType) => {
  // eslint-disable-next-line
  const ctaWithDefindedPropeties = {} as any;
  // only adding non-null properties to cta object
  // eslint-disable-next-line
  for (const property in cta) {
    if (
      cta[property as keyof VendorCTAType] === null ||
      cta[property as keyof VendorCTAType] === undefined
    ) {
      // eslint-disable-next-line
      continue;
    }
    ctaWithDefindedPropeties[property] = cta[property as keyof VendorCTAType];
  }

  return ctaWithDefindedPropeties;
};
// eslint-disable-next-line
export const returnVendorButtonComponent = (
  ctaDetails: VendorCTAType,
  variant: 'primary' | 'secondary',
  vin: string,
  vehicleId?: string,
  market?: string,
  mainDealer?: string,
  vehicleType?: string,
  carType?: string,
) => {
  let vendorComponent = <></>;

  const vendorData = getDefinedPropertiesOfCta(ctaDetails);

  // properties checked will always be unique
  // eslint-disable-next-line
  if (vendorData.hasOwnProperty('ctaVendorLink')) {
    vendorComponent = <CustomCta ctaDetails={ctaDetails} variant={variant} vin={vin} />;
  }
  // eslint-disable-next-line
  if (vendorData.hasOwnProperty('flowOptionGubagoo')) {
    vendorComponent = <GubagooCta ctaDetails={ctaDetails} variant={variant} vin={vin} />;
  }
  // eslint-disable-next-line
  if (vendorData.hasOwnProperty('pagePlacementTypeCarnow')) {
    vendorComponent = <CarnowCta ctaDetails={ctaDetails} variant={variant} vin={vin} />;
  }
  // eslint-disable-next-line
  if (vendorData.hasOwnProperty('actionTypeRoadster')) {
    vendorComponent = <RoadsterCta ctaDetails={ctaDetails} variant={variant} vin={vin} />;
  }
  // eslint-disable-next-line
  if (vendorData.hasOwnProperty('configTypeLocationUpstart')) {
    vendorComponent = <UpstartCta ctaDetails={ctaDetails} variant={variant} vin={vin} />;
  }
  // eslint-disable-next-line
  if (vendorData.hasOwnProperty('vinRecallLabel')) {
    vendorComponent = (
      <VinRecallCta
        ctaDetails={ctaDetails}
        variant={variant}
        vin={vin}
        vehicleType={vehicleType}
        carType={carType}
      />
    );
  }
  // eslint-disable-next-line
  if (vendorData.hasOwnProperty('configTypeLocationDarwin')) {
    vendorComponent = <DarwinCta ctaDetails={ctaDetails} />;
  }
  // eslint-disable-next-line
  if (vendorData.hasOwnProperty('ctaDealerId')) {
    vendorComponent = (
      <ContactDealerCta
        ctaDetails={ctaDetails}
        vehicleType={vehicleType}
        variant={variant}
        vin={vin}
        vehicleId={vehicleId}
        market={market}
        mainDealer={mainDealer}
      />
    );
  }

  return vendorComponent;
};

const VendorCtaSelector = ({
  ctaDetails,
  variant,
  vin,
  vehicleId,
  vehicleType,
  market,
  mainDealer,
  carType,
}: VendorCtaSelectorProps) => {
  return returnVendorButtonComponent(
    ctaDetails,
    variant,
    vin,
    vehicleId,
    market,
    mainDealer,
    vehicleType,
    carType,
  );
};

export default VendorCtaSelector;
